// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2NJmI","colMin":"styles_colMin__1Lc3b"};